import clsx from 'clsx'

import { UniSideNav } from '../navigation/side-nav-uni'

interface ContentWindowProps {
  children: React.ReactNode
  sideNav?: React.ReactNode
  className?: string
}

export function ContentWindow({ children, className = '', sideNav }: ContentWindowProps) {
  const wrapperClasses = clsx(`flex flex-grow flex-col bg-slate-50 ${className}`)
  return sideNav ? (
    <div className={`flex flex-grow bg-slate-50 ${className}`}>
      {sideNav}
      <main
        className={clsx(
          'max-h-[calc(100vh-76px)] overflow-y-auto', // static pixel value slightly larger than header
          'flex flex-1 flex-col border-t border-slate-200',
        )}
      >
        {children}
      </main>
    </div>
  ) : (
    <div className={wrapperClasses}>
      <main
        className={clsx(
          'max-h-[calc(100vh-76px)] overflow-y-auto', // static pixel value slightly larger than header
          'flex flex-1 flex-col border-t border-slate-200 bg-slate-50',
        )}
      >
        {children}
      </main>
    </div>
  )
}

export function WorkatoIframeContentWindow({ children }: { children: React.ReactNode }) {
  return (
    <div className={'flex flex-grow overflow-hidden bg-slate-50'}>
      <UniSideNav />
      <main className='flex flex-1 flex-col overflow-hidden'>{children}</main>
    </div>
  )
}
